module.exports = __webpack_public_path__ + "static/media/APP-min.36faf94b.svg";